import { IMembershipResponse } from '@/types';
import { fetchTemplate } from '@/utils/isServer';
import dayjs from 'dayjs';

export const createMembership = async (
  stripeToken: string,
  email: string
): Promise<IMembershipResponse> => {
  const response = await fetch(`/api/Stripe/Membership/Buy`, {
    ...fetchTemplate,
    method: 'POST',
    body: JSON.stringify({
      Email: email,
      SourceToken: stripeToken,
      ChargeAmount: 0,
      Type: 'annual',
      Currency: 'usd',
      Description:
        'MEMBERFEE: ' + email + ' at ' + dayjs().format('MM/DD/YYYY HH:mm:ss'),
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const data: IMembershipResponse = await response.json();
  return data;
};

export const cancelSelfSubscription = async (): Promise<any> => {
  const response = await fetch(
    `/api/Stripe/Membership/CancelSelfSubscription`,
    {
      ...fetchTemplate,
      method: 'POST',
      body: JSON.stringify({}),
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  const data: IMembershipResponse = await response.json();
  return data;
};

export const createSubscription = async (email: string): Promise<any> => {
  const response = await fetch(`/api/Stripe/Membership/CreateSubscription`, {
    ...fetchTemplate,
    method: 'POST',
    body: JSON.stringify({
      Email: email,
      Description:
        'MEMBERFEESUB: ' +
        email +
        ' at ' +
        dayjs().format('MM/DD/YYYY HH:mm:ss'),
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const data: IMembershipResponse = await response.json();
  return data;
};

export const continueSubscription = async (email, client_secret) => {
  const response = await fetch(`/api/Stripe/Membership/ContinueSubscription`, {
    ...fetchTemplate,
    method: 'POST',
    body: JSON.stringify({
      Email: email,
      ClientSecret: client_secret,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const data: IMembershipResponse = await response.json();
  return data;
};

